module.exports = __webpack_public_path__ + "static/regnio_logo_color-8f1c044634c902536741b6a9000ab2b2.svg";